
import React, { Component } from 'react';
import { connect } from 'react-redux';

import ListItem from 'subscriptions/ListItem';
import * as routes from 'app/routes';

class SprintListItemComponent extends Component {
  render() {
    return <ListItem {...this.props} carrier="sprint" />
  }
}

const mapDispatchToProps = {
  subRoute: routes.sprintSubscription,
}

export default connect(
  null,
  mapDispatchToProps
)(SprintListItemComponent);